import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Translate } from "react-localize-redux";
import { useLocation } from "react-router";

const NavigationTabs = ({ tabs, activeTab, onTabClick, ...rest }) => {
  const [underline, setUnderline] = useState({ width: 0, left: 0 });

  const location = useLocation();

  const checkUnderline = () => {
    const activeEl = document.querySelector(".NavigationTabs .active");

    if (activeEl) {
      if (
        activeEl.width !== underline.width ||
        activeEl.left !== underline.left
      ) {
        const params = {
          width: activeEl.clientWidth,
          left: activeEl.offsetLeft,
        };

        setUnderline(params);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    checkUnderline();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    window.addEventListener("resize", checkUnderline, false);

    return () => {
      window.removeEventListener("resize", checkUnderline, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`NavigationTabs d-flex flex-row justify-content-start align-items-end position-relative ${
        `centerTabs` in rest ? `justify-content-center` : ``
      }`}
    >
      {tabs.map((tab, index) =>
        `isUsingOutlet` in rest ? (
          <NavLink
            key={tab.id}
            className="tab d-flex flex-start align-items-center"
            to={tab.link}
            end
          >
            <p className="title m-0 text-uppercase text-center">
              {tab.customTitle || <Translate id={`page_titles.${tab.title}`} />}
            </p>
          </NavLink>
        ) : (
          <div
            className={`nav-link tab text-dark ${
              (typeof tab === "object" &&
                typeof activeTab === "number" &&
                tab?.id === activeTab) ||
              (typeof activeTab === "string" &&
                typeof tab === "string" &&
                activeTab.toLowerCase().trim() === tab.toLowerCase().trim())
                ? "active border-bottom-orange"
                : "border-bottom-transparent"
            }`}
            role="button"
            key={index}
            onClick={() => onTabClick(typeof tab === "object" ? tab?.id : tab)}
          >
            <p className="title m-0 text-uppercase">
              {typeof tab === "object" ? tab?.label : tab}
            </p>
          </div>
        )
      )}
      {`isUsingOutlet` in rest && (
        <div
          className="underline position-absolute"
          style={{
            width: underline.width,
            left: underline.left,
          }}
        ></div>
      )}
    </div>
  );
};

NavigationTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onTabClick: PropTypes.func,
};

export default NavigationTabs;
